import React, { useEffect } from 'react';
import { Button } from 'semantic-ui-react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useResponsive } from 'ahooks';

import { useAppSelector } from 'src/store';
import {
  selectProgress,
  selectStepContentList,
} from 'src/store/model/class_topic';
import { PATH } from 'src/constants/app';
import { useClassUser, useConfirm } from 'src/hooks';

const NavigateButtons: React.FC = () => {
  const screen = useResponsive();
  const location = useLocation();
  const navigate = useNavigate();
  const { class_id } = useParams();
  const { back, next } = useAppSelector((state) =>
    selectStepContentList(state, class_id, location.pathname),
  );
  const { progress } = useAppSelector((state) =>
    selectProgress(state, class_id!),
  );
  const { open, Confirm } = useConfirm();
  const { final_assessment } = useClassUser();

  const goToAssessment = () => {
    navigate(`/${PATH.ASSESSMENT}/${class_id}`);
  };

  useEffect(() => {
    if (
      progress === 100 &&
      next === undefined &&
      !final_assessment.is_finished
    ) {
      open({
        revert: true,
        title: `Congratulation! You have completed the course.`,
        content: `Put your understanding to the test by answering the final assessment.`,
        okText: `Take final assessment`,
        cancelText: 'Answer later',
        iconProps: {
          name: 'checkmark',
          color: 'purple',
        },
        cancelButtonProps: {
          basic: true,
          fluid: true,
        },
        okButtonProps: {
          fluid: true,
        },
        onOk() {
          goToAssessment();
        },
      });
    }
  }, [progress, next, final_assessment?.is_finished]);

  return (
    <div className="flex-shrink-0">
      {progress === 100 && next === undefined ? (
        <Button
          primary
          floated="right"
          icon={!screen.sm}
          onClick={goToAssessment}
        >
          Final assessment
        </Button>
      ) : (
        <Button
          floated="right"
          disabled={!next}
          onClick={() => {
            if (next) {
              navigate(`/${PATH.CLASS}/${class_id}/${next}`, { replace: true });
            }
          }}
          icon={!screen.sm}
        >
          Next
        </Button>
      )}
      <Button
        floated="right"
        disabled={!back}
        onClick={() => {
          if (back) {
            navigate(`/${PATH.CLASS}/${class_id}/${back}`, { replace: true });
          }
        }}
        icon={!screen.sm}
      >
        Back
      </Button>

      <Confirm />
    </div>
  );
};

export default NavigateButtons;
